import { Injectable } from "@angular/core";
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentContactsTemplate } from "../../../models/SCMTemplates";
import { TemplatesService } from "../../../services/templates.service";

@Injectable()
export class ShipmentContactsTemplatesResolver implements Resolve<Array<ShipmentContactsTemplate>> {

    resolve(): Observable<Array<ShipmentContactsTemplate>> {
        return this.templatesService.getShipmentContactsTemplates();
    }

    constructor(private templatesService: TemplatesService) { }
}